<template>
  <div class="student-list-page">
    <div v-if="$can(Class.actions.edit, Class.subject)">
      <yv-index
        :path="path"
        :formSearch="formSearch"
        :columns="columns"
        :inlineSearchAction="true"
        :bulkActions="tableBulkActions"
        :tableActionsComponent="TableActions"
        :formatTableData="formatTableData"
        :sortable="sortable"
        :sort-data="sortData"
        selectable="multiple"
        mainField="username"
        ref="studentsTable"
      >
        <template #search-actions="{ actions }">
          <div class="flex justify-between">
            <md-button
              native-type="submit"
              @click.native.prevent="actions.search"
              class="md-info md-round"
              >{{ $t("common.search") }}
            </md-button>
            <action-list-button :actions="bulkActions"></action-list-button>
          </div>
        </template>
      </yv-index>
    </div>
    <div v-else>
      <yv-index
        :path="path"
        :formSearch="formSearch"
        :columns="columns"
        :hideAction="true"
        :hideBulkAction="true"
        :inlineSearchAction="true"
        :formatTableData="formatTableData"
        :sortable="sortable"
        :sort-data="sortData"
        mainField="username"
        ref="studentsTable"
      >
      </yv-index>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { Message, capitalizeFirstLetter, getId } from "@/helpers/utils";
import { service_paths, cms_service_paths } from "@/constants/Services";
import { YvIndex } from "@/components/Base";
import TableActions from "./TableActions.vue";
import { Class } from "@/constants/Permissions";
import ActionListButton from "@/components/Base/ActionListButton";
import { generateStatus } from "../../../../helpers/text-helper";

export default {
  name: "student-list",
  components: { YvIndex, ActionListButton },
  props: ["classInfo"],
  inject: ["openAssignmentModal", "getNumberAssignStudent", "exportStudent"],
  data() {
    const classId = this.$route.params.id;
    return {
      studentList: [],
      Class,
      path: `${service_paths.classes}/${classId}/students`,
      formSearch: [
        {
          label: "class.student_filter_id_fullname_email",
          name: "search",
          value: "",
          type: "input",
          width: 40
        }
      ],
      columns: {
        avatar_url: "class.student_col_avatar",
        studentCode: "common.student_code",
        username_link: "common.username",
        full_name: "class.student_col_fullname",
        grade: "common.grade",
        sex: "class.student_col_sex",
        score: "class.student_col_score",
        email: "class.student_col_email",
        assignment_status: "common.status"
      },
      sortable: ["grade"],
      sortData: {
        currentSort: "_id",
        currentSortOrder: "desc"
      },
      tableBulkActions: [
        {
          content: "class.un_assign",
          action: () => {
            this.confirmUnassign();
          }
        }
      ],
      TableActions,
      classId,
      hasStudent: false,
      bulkActions: [
        {
          content: "student.export_student",
          action: this.exportStudentInClass
        },
        {
          content: "student.import_student",
          action: this.showImportXlsxFile
        },
        {
          content: "class.enroll",
          action: this.openAssignmentModal
        }
      ],
      generateStatus
    };
  },
  mounted() {
    this.$axios.get(this.path, { limit: 500 }).then(response => {
      this.studentList = response.data.data;
    });
  },
  methods: {
    exportStudentInClass() {
      if (!this.studentList.length) {
        Message.error(this.$t("export_student.no_data_student"));
      } else {
        this.exportStudent(this.studentList);
      }
    },
    showImportXlsxFile() {
      this.$emit("showImportXlsxFile");
    },
    updateStudentTable() {
      return this.$refs.studentsTable.getTableData();
    },

    confirmUnassign() {
      Swal.fire({
        title: this.$t("class.unassign_students"),
        text: this.$t("class.are_you_sure_unassign_selected_students"),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: this.$t("common.yes"),
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          const students = this.$refs.studentsTable.selectedItems;
          this.unassignStudents(students);
        }
      });
    },

    unassignStudents(students) {
      const usernames = students.map(student => student.username);

      this.$axios
        .post(`${service_paths.classes}/${this.classId}/un-assign-students`, {
          usernames
        })
        .then(async () => {
          Message.success(this.$t("class.unassigned_successfully"));
          await this.getNumberAssignStudent();
          if((students || []).length > 0){
            let para = await students.map(student => {
              return {
                class_id_ref : this.classId,
                user_uuid: student.uuid
              }
            })
            await this.$axios.cms_post(`${cms_service_paths.unassign_students}`, para)
          }
          //Unassign Cms

        });
    },

    setAssignmentStatus(type) {
      const students = this.$refs.studentsTable.selectedItems;
      const assignments = [];
      students.map(student => {
        assignments.push({
          user_id: getId(student),
          status: type
        });
      });

      this.$axios
        .post(`${service_paths.classes}/${this.classId}/assignment-status`, {
          assignments: assignments
        })
        .then(() => {
          Message.success(this.$t("common.update_success"));
          this.updateStudentTable();
        });
    },

    injectFormData(classInfo) {
      if (classInfo?.lms?.name === "agilix") {
        this.tableBulkActions.push(
          {
            content: "student.withdrawal",
            action: () => {
              this.setAssignmentStatus("withdrawal");
            }
          },
          {
            content: "common.active",
            action: () => {
              this.setAssignmentStatus("Active");
            }
          },
          {
            content: "common.inactive",
            action: () => {
              this.setAssignmentStatus("Inactive");
            }
          }
        );
      }
    },

    formatTableData(tableData) {
      this.hasStudent = !!tableData.length;
      return tableData.map(studentData => {
        const numb = Math.random().toFixed(2) * 100000;
        const avatar_url =
          studentData.avatar_url ||
          `https://picsum.photos/50/50?random=${numb}`;
        studentData.avatar_url = `<img src="${avatar_url}" class="object-cover rounded-full w-[42px] h-[42px]">`;
        studentData.assignment_status = this.generateStatus(
          studentData.assignment_status
        );
        const linkStudentDetail = `/students/${getId(studentData)}/detail`;
        studentData.studentCode = `<a href="${linkStudentDetail}">${studentData.student_code}</a>`;
        studentData.username_link = `<a href="${linkStudentDetail}">${studentData.username}</a>`;
        studentData.fullName = `<a href="${linkStudentDetail}">${studentData.full_name}</a>`;
        if ("score" in studentData) {
          studentData.score = Number(studentData.score).toFixed(2);
        }
        return studentData;
      });
    }
  },
  provide() {
    return {
      unassignStudents: this.unassignStudents
    };
  }
};
</script>

<style lang="scss" scoped></style>
